export enum ProfileTypes {
  GENERAL_CONTRACTOR = 'GENERAL CONTRACTOR',
  TRUCKER = 'TRUCKER',
  INDIVIDUAL = 'INDIVIDUAL'
}
